import isServer from "./isServer";

function getAppUrl() {
  if (isServer()) {
    return process.env.API_HOST;
  }

  return window.location.origin;
}

export default getAppUrl;
